import { gtmDataLayerPush } from '../../../gtm'

const contactFormLaunchOriginValues = new Set([
  'amazonisation_account_helpcentre_general',
  'amazonisation_cancellation',
  'amazonisation_changename',
  'amazonisation_changeorder',
  'amazonisation_damagedproduct',
  'amazonisation_payment',
  'amazonisation_payment_delay',
  'amazonisation_payment_reminder',
  'amazonisation_pharma',
  'amazonisation_return',
  'amazonisation_shipping',
  'pdp',
])

export const getContactFormLaunchOriginValues = (
  isLoggedIn: boolean,
  isOrderTypeSubject: boolean,
  contactFormLaunchOrigin?: string,
): string => {
  if (!isLoggedIn && contactFormLaunchOrigin) {
    if (
      isOrderTypeSubject &&
      contactFormLaunchOriginValues.has(contactFormLaunchOrigin)
    ) {
      return 'amazonisation_order_unlogged'
    }

    if (contactFormLaunchOrigin === 'amazonisation_general') {
      return 'amazonisation_general_unlogged'
    }
  }

  if (
    contactFormLaunchOrigin &&
    contactFormLaunchOriginValues.has(contactFormLaunchOrigin)
  ) {
    return contactFormLaunchOrigin
  }

  if (!contactFormLaunchOrigin && isOrderTypeSubject) {
    return 'order'
  }

  return ''
}

export const directContactFormSubmitFullStoryTracking = ({
  contactFormLaunchOriginValue,
}: {
  contactFormLaunchOriginValue: string
}): void => {
  gtmDataLayerPush({
    event: 'fs_event',
    fs_event_data: {
      type: contactFormLaunchOriginValue,
    },
    fs_event_name: 'submit_contact_form',
  })
}
